import { gql } from "@apollo/client";

export const GET_EVENTS = gql`
    query Events($ids: [ID!]!) {
        events(ids: $ids) {
            id
            name
            status
            date
            daysWindow
            organisation {
                id
                logo(size: "small")
                name
                sportType
            }
        }
    }
`;
